import React from "react";
import PaymentAmountTable from "assets/scripts/components/presentational/PaymentAmountTable/PaymentAmountTable";
import keyBy from "lodash/keyBy";
const AmountTable = (props) => {
    const accounts = keyBy(props.accounts, it => it.id);
    const amounts = props.amounts.map(amount => {
        const account = accounts[amount.payableId] || {
            creditor: "",
            acctNum: ""
        };
        return {
            ...amount,
            creditor: account.creditor,
            accountNumber: account.acctNum
        };
    });
    return (<PaymentAmountTable amounts={amounts}/>);
};
export default AmountTable;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/ConfirmPayment/AmountTable/AmountTable.tsx